import React from "react";
import { useNavigate } from "react-router-dom";

function Section({ title, children }) {
  return (
    <div style={{ borderRadius: 24, background: "rgba(255,255,255,0.85)", backdropFilter: "blur(24px)", border: "1px solid rgba(255,255,255,0.8)", boxShadow: "0 26px 60px rgba(24,35,60,0.08)", padding: "32px 36px", marginBottom: 20 }}>
      <p style={{ margin: "0 0 16px", fontSize: 12, fontWeight: 900, color: "#70747e", letterSpacing: 2.2, textTransform: "uppercase" }}>{title}</p>
      {children}
    </div>
  );
}

function Row({ bold, text }) {
  return (
    <div style={{ padding: "16px 0", borderTop: "1px solid rgba(0,0,0,0.05)" }}>
      <div style={{ fontSize: 14, fontWeight: 800, color: "#111", marginBottom: 6 }}>{bold}</div>
      <div style={{ fontSize: 14, color: "#6b7280", lineHeight: 1.7 }}>{text}</div>
    </div>
  );
}

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(180deg,#f5f7fb 0%,#eef1f7 45%,#f7f8fb 100%)", paddingTop: 90, paddingBottom: 80, fontFamily: "-apple-system, BlinkMacSystemFont, Inter, Helvetica, Arial, sans-serif" }}>
      <div style={{ width: "min(780px, calc(100% - 40px))", margin: "0 auto" }}>

        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", fontSize: 17, fontWeight: 700, color: "#0a84ff", cursor: "pointer", padding: 0, marginBottom: 16, display: "block" }}>
            ‹ Back
          </button>
          <p style={{ margin: 0, fontSize: 12, fontWeight: 800, letterSpacing: 2.4, color: "#7b7f89" }}>ELEVEN MARINE</p>
          <h1 style={{ margin: "6px 0 8px", fontSize: 42, letterSpacing: -1.5, fontWeight: 800, color: "#050505" }}>Privacy Policy</h1>
          <p style={{ margin: 0, fontSize: 16, color: "#6b7280", lineHeight: 1.6 }}>
            Last updated January 1, 2026. This policy explains how ELEVEN Industries collects, uses, and protects your personal information.
          </p>
        </div>

        <Section title="Information We Collect">
          <Row bold="Account Information" text="When you create an account, we collect your name, email address, phone number, and password. This information is used to manage your account, process orders, and communicate with you." />
          <Row bold="Order & Transaction Data" text="We collect details about the parts you purchase, including order numbers, shipping addresses, payment method types (not full card numbers), and order history." />
          <Row bold="Usage Data" text="We may collect information about how you interact with the ELEVEN platform, including pages visited, search queries, and vehicle fitment selections. This data helps us improve the platform." />
          <Row bold="Device & Technical Data" text="We collect standard technical information such as your browser type, IP address, and device identifiers when you access our website or app." />
        </Section>

        <Section title="How We Use Your Information">
          <Row bold="Order Fulfillment" text="Your personal and shipping information is used solely to process, fulfill, and deliver your orders. We do not sell your data to third parties for marketing purposes." />
          <Row bold="Account Management" text="Your account information is used to provide access to your order history, store credit balance, return requests, and saved vehicle fitments." />
          <Row bold="Customer Support" text="When you contact ELEVEN support, we use your information to identify your account and resolve your inquiry efficiently." />
          <Row bold="Platform Improvement" text="Aggregated and anonymized usage data helps us improve search relevance, product listings, and the overall shopping experience." />
          <Row bold="Communications" text="We may send you transactional emails related to your orders, returns, and account activity. You may opt out of promotional communications at any time." />
        </Section>

        <Section title="Data Sharing">
          <Row bold="Shipping Partners" text="We share your name and shipping address with our logistics and shipping partners solely for the purpose of delivering your order." />
          <Row bold="Payment Processors" text="Payment information is handled by our PCI-compliant payment processor. ELEVEN does not store full credit card numbers on our servers." />
          <Row bold="No Third-Party Marketing" text="We do not sell, rent, or share your personal information with third parties for advertising or marketing purposes under any circumstances." />
          <Row bold="Legal Requirements" text="We may disclose your information if required by law, court order, or to protect the rights and safety of ELEVEN Industries and its customers." />
        </Section>

        <Section title="Data Security">
          <Row bold="Encryption" text="All data transmitted between your device and ELEVEN servers is encrypted using industry-standard TLS/SSL protocols." />
          <Row bold="Access Controls" text="Access to customer data is restricted to authorized ELEVEN personnel on a need-to-know basis." />
          <Row bold="Data Retention" text="We retain your account and order data for as long as your account is active or as required for legal and business purposes. You may request deletion of your account at any time." />
        </Section>

        <Section title="Your Rights">
          <Row bold="Access & Correction" text="You may access and update your personal information at any time through your account settings or by contacting support@eleven11marine.com." />
          <Row bold="Account Deletion" text="You may request the deletion of your account and associated personal data by contacting our support team. Certain transaction records may be retained for legal compliance." />
          <Row bold="Opt-Out" text="You may opt out of non-transactional email communications at any time using the unsubscribe link in any email or by contacting support." />
        </Section>

        <Section title="Contact">
          <div style={{ fontSize: 14, color: "#6b7280", lineHeight: 1.8 }}>
            For privacy-related inquiries, contact us at:<br />
            <strong style={{ color: "#111" }}>support@eleven11marine.com</strong><br />
            ELEVEN Industries · Miami, Florida
          </div>
        </Section>

      </div>
    </div>
  );
}